export const allowedFileExtensions = ['xlsx'];

const isValidExtension = (value: string) => allowedFileExtensions.some(extension => value.endsWith(`.${extension}`));

export const validatePortalListFile = (value: File | string) => {
  const fileName = value instanceof File ? value.name : value;

  if (fileName && !isValidExtension(fileName)) {
    return `Only .${allowedFileExtensions.join(', .')} files are accepted`;
  }

  return undefined;
};
